/* Share link component for product pages
   Targets: .single-product__content-head-share (button)
   Behavior:
   - Copies current URL (or data-share-url) to clipboard on click
   - Emits 'share:success' | 'share:error' events
*/
(function () {
    'use strict';

    function getShareButton() {
        return document.querySelector('.single-product__content-head-share');
    }

    function getUrl(btn) {
        const dataUrl = btn && btn.getAttribute('data-share-url');
        return dataUrl || window.location.href;
    }

    function copyToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text);
        }
        return new Promise(function (resolve, reject) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                const ok = document.execCommand('copy');
                document.body.removeChild(textarea);
                ok ? resolve() : reject(new Error('execCommand failed'));
            } catch (e) {
                document.body.removeChild(textarea);
                reject(e);
            }
        });
    }

    function markShared(btn) {
        btn.classList.add('is-shared');
        setTimeout(function () {
            btn.classList.remove('is-shared');
        }, 1000);
    }

    function handleClick(e) {
        const btn = e.currentTarget;
        e.preventDefault();
        const url = getUrl(btn);
        // Prefer Web Share API with URL only; fallback to copy
        if (navigator.share) {
            navigator
                .share({ url: url })
                .then(function () {
                    markShared(btn);
                    btn.dispatchEvent(
                        new CustomEvent('share:success', {
                            bubbles: true,
                            detail: { method: 'web-share', url },
                        })
                    );
                })
                .catch(function (err) {
                    // If user cancels, do not treat as error; otherwise fallback to copy
                    if (err && (err.name === 'AbortError' || err.name === 'NotAllowedError')) {
                        return;
                    }
                    copyToClipboard(url)
                        .then(function () {
                            markShared(btn);
                            btn.dispatchEvent(
                                new CustomEvent('share:success', {
                                    bubbles: true,
                                    detail: { method: 'copy', url },
                                })
                            );
                        })
                        .catch(function (copyErr) {
                            btn.dispatchEvent(
                                new CustomEvent('share:error', {
                                    bubbles: true,
                                    detail: { error: copyErr && copyErr.message ? copyErr.message : String(copyErr) },
                                })
                            );
                        });
                });
            return;
        }
        // No Web Share API
        copyToClipboard(url)
            .then(function () {
                markShared(btn);
                btn.dispatchEvent(
                    new CustomEvent('share:success', {
                        bubbles: true,
                        detail: { method: 'copy', url },
                    })
                );
            })
            .catch(function (err) {
                btn.dispatchEvent(
                    new CustomEvent('share:error', {
                        bubbles: true,
                        detail: { error: err && err.message ? err.message : String(err) },
                    })
                );
            });
    }

    function init() {
        const btn = getShareButton();
        if (!btn) return;
        btn.addEventListener('click', handleClick);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();


